import { customFieldSchemaGQLFields, } from './customFieldSchema.fields.js';
const BASIC_CUSTOM_FIELDS_SCHEMA_FIELDS = {};
const ALL_CUSTOM_FIELDS_SCHEMA_FIELDS = {
    fields: 'all',
};
export const customFieldsSchemaGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_CUSTOM_FIELDS_SCHEMA_FIELDS;
    if (fields === 'all')
        fields = ALL_CUSTOM_FIELDS_SCHEMA_FIELDS;
    return `
  __typename
  ${fields.fields
        ? `
    fields {
      ${customFieldSchemaGQLFields(fields.fields)}
    }
  `
        : ``}
`;
};
//# sourceMappingURL=customFieldsSchema.fields.js.map